import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import useClosestVehicle from '~/hooks/new-cars/selectors/useClosestVehicle';

export default function useSelectionsPrice() {
  const { customizeOptions, selectedOptions } = useContext(ParentModelContext);
  const closestVehicle = useClosestVehicle();

  const {
    basePrice,
    driveTypes,
    engines,
    exteriorColors,
    interiorColors,
    packageOptions
  } = customizeOptions.data;

  return closestVehicle
    ? closestVehicle.incentivizedPrice
    : basePrice +
        exteriorColors.reduce(
          (acc, { code, priceAdd }) =>
            selectedOptions?.exteriorColorCode === code ? acc + priceAdd : acc,
          0
        ) +
        interiorColors.reduce(
          (acc, { code, priceAdd }) =>
            selectedOptions?.interiorColorCode === code ? acc + priceAdd : acc,
          0
        ) +
        driveTypes.reduce(
          (acc, { name, priceAdd }) =>
            selectedOptions?.driveType === name ? acc + priceAdd : acc,
          0
        ) +
        engines.reduce(
          (acc, { code, priceAdd }) =>
            selectedOptions?.engineCode === code ? acc + priceAdd : acc,
          0
        ) +
        packageOptions.reduce(
          (acc, { code, priceAdd }) =>
            selectedOptions?.packageOptionCodes?.includes(code)
              ? acc + priceAdd
              : acc,
          0
        );
}
